import cypher from './js/cypher';
import $ from 'jquery';
import './sass/style.scss';

// import logo from './images/logo.png';

new cypher($).init();
